/**
 * PushFilterButtonToTitleExtra Handler для HeaderPage
 * 
 * Додає кнопку фільтра в titleExtra для десктопного та мобільного режимів
 */

import { Button } from '@/Core/UI/Button'
import { BiFilterAlt } from 'react-icons/bi'

/**
 * Додає кнопку фільтра в titleExtra
 * 
 * @param params - параметри з headerPageContext
 */
export const PushFilterButtonToTitleExtra = ({ headerPageContext }: any) => {
    const crudContext = headerPageContext?.storages?.crudContext
    
    if (!crudContext || crudContext.contextType == 'detail') return
    
    headerPageContext.titleExtra ??= []
    
    headerPageContext.titleExtra.push(
        <Button
            key='crudresource-filterbutton-headerpage-desktop'
            depFn={() => {
                const variant = crudContext?.listContext?.variant
                const variantItems = crudContext?.listContext?.variantItems ?? {}
                const variantHasFilter = variantItems[variant]?.hasFilter !== false
                return crudContext.isFilter && variantHasFilter
            }}
            type='link'
            onClick={() => {
                crudContext.setIsFilterOpen(!crudContext.isFilterOpen)
            }}
            icon={<BiFilterAlt style={{ fontSize: 24 }} />}
        />
    )
}
